// extracted by mini-css-extract-plugin
export default {"heading":"style_heading__Uj9py","text":"style_text__F8V-Z"};